export const getters = {
    route: (state) => {
        return state.route;
    },
    country: (state) => {
        return state.country;
    },
    inquiry: (state) => {
        return state.inquiry;
    },
    travelData: (state) => {
        return state.travelData;
    },
    phoneValid: (state) => {
        return state.phoneValid;
    },
    emailValid: (state) => {
        return state.emailValid;
    },
    mailchimpSignup: (state) => {
        return state.mailchimpSignup
    },
    pending: (state) => {
        return state.pending;
    },
    error: (state) => {
        return state.error;
    },
};
